import apiClient from './apiClient';

const likesApi = {
  likeProfile: (userId: string) =>
    apiClient.post(`/likes/${userId}`).then((r) => r.data),

  unlikeProfile: (userId: string) =>
    apiClient.delete(`/likes/${userId}`).then((r) => r.data),

  getLikedProfiles: () =>
    apiClient.get('/likes/liked').then((r) => r.data),

  getWhoLikedMe: () =>
    apiClient.get('/likes/liked-me').then((r) => r.data),

  getMatches: () =>
    apiClient.get('/likes/matches').then((r) => r.data),

  checkLike: (userId: string) =>
    apiClient.get(`/likes/check/${userId}`).then((r) => r.data),
};

export default likesApi;
